module.exports = __webpack_public_path__ + "static/media/logo.0ba31d5b.svg";